import React from 'react';
import { useHistory } from 'react-router-dom';

// function
import MoveWithMarketo from 'function/MoveWithMarketo';

// scss
import './Modal.scss';

// json
import {areaType} from 'json/allData';

type Props = {
  testPath: string,
  currentFloor: number,
  currentArea: number,
  activeSlide: number,
  activeModal: number,
  currentAreaObj: areaType,
  handleCloseModal: any,
}

const Header: React.FC<Props> = (props) => {

  // history
  const history = useHistory();

  return (
    <div id="Modal" className='modalBg st-open'>
      <div className="modal">
        <div className="scroll">
            {props.currentAreaObj.slides[props.activeSlide].modals[props.activeModal].title === '動画' ?
              // ムービーモーダル
              <div className="modalInner isMovie">
                <div><div><iframe src={props.currentAreaObj.slides[props.activeSlide].modals[props.activeModal].url} allowFullScreen={true} allow="encrypted-media" title="movie"></iframe></div></div>
              </div>
            :
              // 通常モーダル
              <div className="modalInner">
                <div className="leftArea"><img src={`${props.testPath}/asset/floor/floor${props.currentFloor}_area${props.currentArea}_slide${props.activeSlide}_modal${props.activeModal}.png`} alt=""/></div>
                <div className="rightArea">
                  <div className="productName" dangerouslySetInnerHTML={{__html: props.currentAreaObj.slides[props.activeSlide].modals[props.activeModal].title}}></div>
                  <div className="lead1" dangerouslySetInnerHTML={{__html: props.currentAreaObj.slides[props.activeSlide].modals[props.activeModal].lead1}}></div>
                  <div className="lead2" dangerouslySetInnerHTML={{__html: props.currentAreaObj.slides[props.activeSlide].modals[props.activeModal].lead2}}></div>
                  <div className="btnArea"><a href={props.currentAreaObj.slides[props.activeSlide].modals[props.activeModal].url} onClick={(e)=>{MoveWithMarketo(e, history)}} rel="noreferrer" target="_blank">製品サイトへ</a></div>
                </div>
              </div>
            }
          <div className="btnCloseArea"><a href="/" onClick={(e)=>{props.handleCloseModal(e)}}>CLOSE</a></div>
        </div>
      </div>
    </div>
  );
}

export default Header;
